import { render, staticRenderFns } from "./DialogSignContract.vue?vue&type=template&id=64e88f61"
import script from "./DialogSignContract.vue?vue&type=script&lang=js"
export * from "./DialogSignContract.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports